import React from 'react'

import { Box, Checkbox, RadioButton, Text } from '@factorialco/deprecated-design-system'
import { xor } from 'lodash'

import LabeledInput from '../../../core/components/LabeledInput'
import i18n from '../../../core/lib/i18n'
import { Element } from '../../lib/Element'
import { Answer } from '../../lib/types'
import * as styles from './index.vanilla.css'

interface OptionElementQuestionProps {
  element: Element
  hasAttemptedSubmit?: boolean
  isSingleChoice: boolean
  onChange?: (answer: Answer) => void
}

/**
 * Editor component for TextElement
 */
export const OptionElementQuestion: React.FC<OptionElementQuestionProps> = ({
  element,
  hasAttemptedSubmit = false,
  isSingleChoice,
  onChange,
}) => {
  const [choiceAnswers, setChoiceAnswers] = React.useState<string[]>([]) //TODO get current value
  const answersString = choiceAnswers.join(',')
  const handleChange = (optionId: string) => {
    const isSingleOptionSelected = optionId === choiceAnswers[0]
    const singleAnswer = isSingleChoice && isSingleOptionSelected ? [] : [optionId]
    const selectedChoices = isSingleChoice ? singleAnswer : xor(choiceAnswers, [optionId])
    setChoiceAnswers(selectedChoices)
    onChange?.({
      answer: selectedChoices.join(','),
      options: selectedChoices,
    })
  }
  const isMandatoryAndEmpty = element.mandatory && choiceAnswers.length === 0
  return (
    <Box gap="s16">
      <Text.Normal size="200" color="grey800">
        {!isSingleChoice
          ? i18n.t('questionnaires.answers.choice.all_options')
          : i18n.tp('questionnaires.answers.choice.max_options', {
              count: !isSingleChoice ? element.options.length : 1,
            })}
      </Text.Normal>
      <Box
        gap="s8"
        role="group"
        aria-labelledby={`question-${element.id}`}
        className={styles.options}
      >
        {element.options.map((option, i) => {
          const checked = choiceAnswers.includes(option.id ?? '') || false
          return (
            <LabeledInput
              key={option.value}
              mandatory={element.mandatory && i == 0}
              value={answersString}
              readonly={!onChange}
              error={
                hasAttemptedSubmit && isMandatoryAndEmpty
                  ? 'Missing mandatory field' // TODO Translate
                  : undefined
              }
            >
              <Box
                key={option.value}
                flexDirection="row"
                padding="s12"
                gap="s8"
                alignItems="center"
                cursor="pointer"
              >
                {!isSingleChoice && (
                  <Checkbox
                    size="small"
                    value={option.id}
                    // disabled={!onChange}
                    checked={checked}
                    label={option.label}
                    onChange={() => handleChange(option.id ?? '')}
                  />
                )}
                {isSingleChoice && (
                  <RadioButton
                    size="small"
                    value={option.id ?? ''}
                    label={option.label}
                    // disabled={!onChange}
                    checked={checked}
                    onChange={() => handleChange(option.id ?? '')}
                  />
                )}
              </Box>
            </LabeledInput>
          )
        })}
      </Box>
    </Box>
  )
}
